/*
 * @Author: Src
 * @Date: 2024-12-29 16:30:01
 * @LastEditTime: 2026-04-27 15:12:23
 * @LastEditors: Src
 * @FilePath: /work-station/src/common/utils/permission-manager.ts
 * @Description: 权限管理
 */
import { BehaviorSubject, from, throttleTime, distinctUntilChanged, mergeMap, Subject } from 'rxjs';
import { BASE_URL } from '@/common/constant/index';
import axios from 'axios';
import { message } from 'ant-design-vue';

class PermissionManager {
  private eventsMap: Map<string, any>;

  private resultMap: Map<string, any>;

  public constructor() {
    this.eventsMap = new Map();
    this.resultMap = new Map();
  }

  private getData(names: string) {
    const userStorage = localStorage.getItem('user');
    // console.log(names, 'permission-manager');
    // const userId = userStorage ? JSON.parse(userStorage).id : null;
    const AUTHORIZATION = userStorage ? JSON.parse(userStorage).token : null;
    const permissionStorage: any = localStorage.getItem('permission') || '{}';
//  const nanelist = names.split(',');
//  console.log(nanelist, 'nanelist');
    if (Object.prototype.hasOwnProperty.call(JSON.parse(permissionStorage), names)) {
      const permissionMap = new Map();
      if (permissionStorage) {
        for (const [key, val] of Object.entries(JSON.parse(permissionStorage))) {
          permissionMap.set(key, val);
        }
      }
      const sPromise = new Promise((resolve) => {
        const _temp: any = {};
        _temp[names] = permissionMap.get(names).value;
        // console.log(_temp, 'permissionMap.get(names)');
        resolve(_temp);
      });
      return sPromise;
    } else {
    const item = axios.post(`${BASE_URL}/rbac/permission/list`, {
      loadingEl: document.body,
      permission_name: names,
    }, {
      headers: {
        AUTHORIZATION,
      },
    });
      item.then((res) => {
        console.log(res, 'res');
      }).catch((err) => {
        if (err.response.status === 401) {
          message.error('登录已过期，请重新登录');
          window.location.hash = '#/login';
          location.reload();
        }
      });
      return item;
    }
  }

  public send(namesList: string[]) {
    const names = namesList.join(',');
    let result = this.resultMap.get(names);
    if (!result) {
      result = new BehaviorSubject({});
      this.resultMap.set(names, result);
    }

    let events = this.eventsMap.get(names);
    if (!events) {
      events = new Subject();
      events
        .pipe(
          throttleTime(3000),
          mergeMap((name2: string) => from(this.getData(name2))),
          distinctUntilChanged((a: object, b: object) => {
            return JSON.stringify(a) === JSON.stringify(b);
          }),
        )
        .subscribe(result);
      this.eventsMap.set(names, events);
    }

    events.next(names);
    return result;
  }

  /**
   * 清除权限管理
   */
  public clear() {
    this.resultMap.clear();
    this.eventsMap.clear();
  }
}

const manager = new PermissionManager();
export default manager;
